import { TaskAssignee } from "./types";

export interface AssigneePillStyle {
  bg: string;
  text: string;
  dot: string;
  border: string;
  label: string;
}

const TEAM_MEMBER_STYLE = { bg: "bg-violet-50", text: "text-violet-700", dot: "bg-violet-500", border: "border-violet-200" };
const CLIENT_STYLE = { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500", border: "border-amber-200" };
const UNASSIGNED_STYLE = { bg: "bg-slate-100", text: "text-slate-600", dot: "bg-slate-400", border: "border-slate-200" };

export function assigneeDisplayName(assignee: TaskAssignee): string {
  // A portal team member has no email. The server names them "Team" when nameless (TD-103).
  return assignee.name?.trim() ? assignee.name : assignee.email ?? "Team";
}

export function assigneePillStyle(assignee: TaskAssignee | null): AssigneePillStyle {
  if (!assignee) return { ...UNASSIGNED_STYLE, label: "Team" };
  const base = assignee.kind === "team" ? TEAM_MEMBER_STYLE : CLIENT_STYLE;
  return { ...base, label: assigneeDisplayName(assignee) };
}
